import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Item } from './models/item.model';
import { ApiService } from '../../shared/services/api.service';
import { API_BASE_URL } from '../../shared/tokens/api.tokens';
import { ResultSet } from '../../shared/models/result-set.model';
import { catchError } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { ErrorHandlerService } from '../../shared/services/error-handler.service';

@Injectable({
  providedIn: 'root'
})
export class ItemsService extends ApiService<Item> {

  readonly _baseUrl: string;  

  readonly searchFields = ['name'];

  constructor(@Inject(API_BASE_URL) apiBaseUrl: string, http: HttpClient, errorHandler: ErrorHandlerService) { 
      super(http, errorHandler);
      this._baseUrl = `${apiBaseUrl}items/`;    
    }

    getItemsForPlot(plotId: number, offset: number = 0, limit: number = 10) {
      const params = new HttpParams()
        .set('offset', offset.toString())
        .set('limit', limit.toString());
      return this.http.get<ResultSet<Item>>(`${this._baseUrl}for-plot/${plotId}`, { params }).pipe(
        catchError(this.handleError)
      );
    }
    
   
}
